import { cn } from '@fsd/ui';
import { Star } from '@solar-icons/react';
import { useState } from 'react';

interface StarRatingProps {
  value: number;
  onChange: (value: number) => void;
  max?: number;
}

export function StarRating({ value, onChange, max = 5 }: StarRatingProps) {
  const [hoverValue, setHoverValue] = useState<number | null>(null);

  return (
    <div className="flex items-center gap-2">
      {/* biome-ignore lint/a11y/noStaticElementInteractions: Mouse leave is used for visual feedback only */}
      <div className="flex gap-1" onMouseLeave={() => setHoverValue(null)}>
        {Array.from({ length: max }).map((_, index) => {
          const starValue = index + 1;
          const isFilled = (hoverValue ?? value) >= starValue;

          return (
            <button
              key={starValue}
              type="button"
              className="focus:outline-none transition-transform hover:scale-110"
              onClick={() => onChange(starValue)}
              onMouseEnter={() => setHoverValue(starValue)}
              aria-label={`Avaliar com ${starValue} estrela${starValue > 1 ? 's' : ''}`}
            >
              <Star
                size={24}
                weight={isFilled ? 'Bold' : 'Outline'}
                className={cn(
                  'transition-colors',
                  isFilled ? 'text-yellow-400' : 'text-muted-foreground'
                )}
              />
            </button>
          );
        })}
      </div>
      <span className="text-sm font-medium text-muted-foreground w-8">
        {(hoverValue ?? value).toFixed(1)}
      </span>
    </div>
  );
}
